import React, { useState, useEffect } from "react";

import {

  Grid,

  TextField,

  Button,

  Box,

  Autocomplete,

} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useUploadHistory } from '../../templates/CJWManageHistory/CJWManageHistory.hooks';
// Your JSON data



export default function CjwFilters({ callBack, isDIMode = false }) {

  const { fetchFilterUploads } = useUploadHistory();
  const { uploadHistory } = useUploadHistory();
  const [responseData, setResponseData] = useState([]);
  const [formValues, setFormValues] = useState({
    fileName: "",
    uploadedBy: "",
    startDate: null,
    endDate: null,
    category: "",
    supplierFlag: "",
    status: "",
    supplierName: "",
    isTariff: "",
    valid: "",
  });

  // Helper: extract unique values from JSON

  const getUnique = (key) => [

    ...new Set(responseData.map((item) => item[key]).filter(Boolean)),

  ];

  const handleChange = (name, value) => {

    setFormValues({

      ...formValues,

      [name]: value,

    });

  };

  const filterObject = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) =>
        value !== null && value !== undefined && value !== ''
      )
    );
  };


  const handleSubmit = async () => {
    // let params = {
    //   startDate: formValues.startDate,
    //   endDate: formValues.endDate,
    //   fileName: formValues.fileName,
    //   status: formValues.status,
    //   supplierName: formValues.supplierName,
    //   isTariff: formValues.isTariff,
    //   uploadedBy: formValues.uploadedBy,
    // };
    const filteredParams = filterObject(formValues);
    let keys = Object.keys(filteredParams);

    keys.forEach(key => {
      if (key === "startDate" && filteredParams['startDate'] !== null) {
        const dateString = filteredParams.startDate;
        const date = new Date(dateString);
        // Specify the 'en-GB' locale for DD/MM/YYYY formatting
        const formattedDate = date.toLocaleDateString('en-US');
        filteredParams.startDate = formattedDate;
      }
      if (key === "endDate" && filteredParams['endDate'] !== null) {
        const dateString = filteredParams.endDate;
        const date = new Date(dateString);
        // Specify the 'en-GB' locale for DD/MM/YYYY formatting
        const formattedDate = date.toLocaleDateString('en-US');
        filteredParams.endDate = formattedDate;
      }
    });

    const data = await fetchFilterUploads(filteredParams);
    callBack(data);

  };

  useEffect(() => {
    setResponseData(uploadHistory);
  }, [uploadHistory])

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ p: 3 }}>
        <Grid container spacing={2}>

          {/* Row 1 */}
          <Grid item xs={3}>
            <Autocomplete
              options={getUnique("fileName")}
              value={formValues.fileName}
              onChange={(e, val) => handleChange("fileName", val)}
              renderInput={(params) => (
                <TextField {...params} label="Filename" size="medium" />
              )}
            />
          </Grid>
          {/* <Grid item xs={3}>
            <Autocomplete

              options={getUnique("uploadedBy")}

              value={formValues.uploadedBy}

              onChange={(e, val) => handleChange("uploadedBy", val)}

              renderInput={(params) => (
                <TextField {...params} label="Uploaded By" size="medium" />

              )}

            />
          </Grid> */}
          <Grid item xs={3}>
            <DatePicker

              label="Start Date"

              value={formValues.startDate}

              onChange={(val) => handleChange("startDate", val)}

              slotProps={{ textField: { fullWidth: true, size: "medium" } }}

            />
          </Grid>
          <Grid item xs={3}>
            <DatePicker

              label="End Date"

              value={formValues.endDate}

              onChange={(val) => handleChange("endDate", val)}

              slotProps={{ textField: { fullWidth: true, size: "medium" } }}

            />
          </Grid>

          {/* Row 2 */}
          {/* <Grid item xs={3}>
            <Autocomplete

              options={getUnique("category")}

              value={formValues.category}

              onChange={(e, val) => handleChange("category", val)}

              renderInput={(params) => (
                <TextField {...params} label="Category" size="medium" />

              )}

            />
          </Grid> */}
          {!isDIMode && (
          <Grid item xs={3}>
            <Autocomplete
              options={getUnique("supplierFlag")}
              value={formValues.supplierFlag}
              onChange={(e, val) => handleChange("supplierFlag", val)}
              renderInput={(params) => (
                <TextField {...params} label="APG/ASG" size="medium" />
              )}
            />
          </Grid>
          )}
          <Grid item xs={3}>
            <Autocomplete

              options={getUnique("status")}

              value={formValues.status}

              onChange={(e, val) => handleChange("status", val)}

              renderInput={(params) => (
                <TextField {...params} label="Status" size="medium" />

              )}

            />
          </Grid>
          {/* <Grid item xs={3}>
            <Autocomplete
              options={getUnique("supplierName")}
              value={formValues.supplierName}
              onChange={(e, val) => handleChange("supplierName", val)}
              renderInput={(params) => (
                <TextField {...params} label="supplier Name" size="medium" />
              )}
            />
          </Grid> */}

          {/* Row 3 */}
          <Grid item xs={3}>
            <Autocomplete
              options={getUnique("isTariff")}
              value={formValues.isTariff}
              onChange={(e, val) => handleChange("tariffStatus", val)}
              renderInput={(params) => (
                <TextField {...params} label="Tarrif Type" size="medium" />
              )}
            />
          </Grid>
          {/* <Grid item xs={3}>
            <TextField
              fullWidth
              label="Valid"
              name="valid"
              size="medium"
              value={formValues.valid}
              onChange={(e) => handleChange("valid", e.target.value)}
            />
          </Grid> */}

          {/* Submit Button */}
          <Grid item xs={12} sx={{ textAlign: "right", mt: 2 }}>
            <Button

              variant="contained"

              color="primary"

              size="medium"

              onClick={handleSubmit}
            >

              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
    </LocalizationProvider>

  );

}

